import { render, staticRenderFns } from "./snackbars.vue?vue&type=template&id=0516c870"
import script from "./snackbars.vue?vue&type=script&lang=ts"
export * from "./snackbars.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports